<template>
  <div class="compareMenu">
    <!--头部菜单 -->
    <a-menu class="menuWrapper"
            v-model="current"
            mode="horizontal">
      <a-menu-item key="menu1"
                   @click="menuClick"> 曲线对比 </a-menu-item>
      <a-menu-item key="menu2"
                   @click="menuClick"> AQI占比 </a-menu-item>
      <a-menu-item key="menu3"
                   @click="menuClick"> 同比环比 </a-menu-item>
      <a-menu-item key="menu4"
                   @click="menuClick"> 风速风向 </a-menu-item>
    </a-menu>
    <!-- body -->
    <div class="bodyWrapper" id="bodyWrapperId">
      <!-- 选择设备弹框 -->
      <el-dialog title="选择设备" :visible.sync="selectDeviceDialog" width="80%">
         <selectDevice ref="child" :selectedRow="defaultSelected"  @selectChange="selectChange"/>
      </el-dialog>
      <!-- 曲线对比 -->
      <Curve class="minWidth"
             v-show="pageName == 'menu1'"
             :paramsObject="paramsObject"
             @isShow = "isShow"
            />

      <!-- AQI占比 -->
      <AQI class="minWidth"
           v-show="pageName == 'menu2'"
           :paramsObject="paramsObject"
            @isShow = "isShow"
            />

      <!-- 同比环比 -->
      <Year class="minWidth"
            v-show="pageName == 'menu3'"
            :paramsObject="paramsObject"
             @isShow = "isShow"
             />

      <!-- 玫瑰图 -->
       <windRose class="minWidth"
            v-show="pageName == 'menu4'"
            :paramsObject="paramsObject"
             @isShow = "isShow"
            />
    </div>
  </div>
</template>

<script>
import MixinSD from '@/store/sd/mixinsSd.js'
import Curve from '@/components/dataCompare/curve.vue'
import AQI from '@/components/dataCompare/AQI.vue'
import Year from '@/components/dataCompare/year.vue'
import windRose from '@/components/dataCompare/windRose.vue'
import selectDevice from '@/components/dataCompare/children/selectDevice.vue'
export default {
  mixins: [MixinSD],
  components: {
    Curve,
    AQI,
    Year,
    windRose,
    selectDevice
  },
  data () {
    return {
      current: ['menu1'],
      pageName: 'menu1',
      defaultSelected:[], // 默认选中设备15台(不会更改)
      paramsObject: [], // 传递给图表的默认设备数据
      selectDeviceDialog: false,
      deviceList:[],
    }
  },
  created () {
    this.getAreaList()
    this.getDeviceParams()
    this.getSelectRow()
  },
  mounted () {
    this.$nextTick(() => {
      const pageName = window.sessionStorage.getItem('pageName')
      if (pageName) {
        this.current[0] = pageName
        this.pageName = pageName
      } else {
        this.current[0] = 'menu1'
      }
    })
  },
  methods: {
    getAreaList () { // 获取地区列表下的国控空气站
      var ts = this.stringTime(new Date())
      var data = {
        account: window.localStorage.getItem('account'),
        is_all: 1,
        is_gkz: 1,
        token: window.localStorage.getItem('token'),
        ts
      }
      const that = this
      this.getAreaListSD(data).then(function (value) {
        const result = value.data.data
        if (result.length === 0) {
          this.$message.warning('暂无国控站')
        }
        that.$bus.$emit('setal', result)
      })
    },
    getDeviceParams () { // 获取用户设备接收参数
      var ts = this.stringTime(new Date())
      var data = {
        account: window.localStorage.getItem('account'),
        token: window.localStorage.getItem('token'),
        ts
      }
      const that = this
      this.getDeviceParamsSD(data).then(function (value) {
        const result = value.data.data
        that.$store.commit('updateEparam', result)
      })
    },
    isShow(val) {
      this.selectDeviceDialog = val
    },
    selectChange(val,i) {
      this.paramsObject = val
      this.selectDeviceDialog = i
    },
    getSelectRow() {
      var ts = this.stringTime(new Date())
      var data = {
        account: window.localStorage.getItem('account'),
        is_all: 1,
        is_gkz: 2,
        token: window.localStorage.getItem('token'),
        ts
      }
      const that = this
      this.getAreaListSD(data).then(function (value) {
        that.paramsObject = value.data.data.slice(0,15)
        that.defaultSelected = value.data.data.slice(0,15)
        that.deviceList = value.data.data
        let compareData = []
        compareData =  that.$route.query.compareData
        if(compareData) {
          console.log('进入数据对比模式,默认切换到曲线对比tab');
          that.current[0] = 'menu1'
          that.pageName = that.current[0]
          window.sessionStorage.setItem('pageName', 'menu1')
          that.paramsObject = []
          that.defaultSelected = []
          that.deviceList.forEach(item=> {
            compareData.forEach(j=> {
              if(item.code == j) {
                that.paramsObject.push(item)
                that.defaultSelected.push(item)
              }
            })
          })
        }
      })
    },
    menuClick: function (item, key, keyPath) {
      window.sessionStorage.setItem('pageName', item.key)
    }
  },
  watch: {
    current: function () {
      this.pageName = this.current[0]
    },
    $route: {
      handler(newVal,oldVal) {
        this.getSelectRow();
      },
      deep: true
    }
  },
}
</script>

<style lang="less" scoped>
/* 头部菜单 */
.ant-menu {
  line-height: 0.64rem;
  padding: 0 0.08rem;
  font-size: 0.16rem;
  color: rgba(0, 0, 0, 0.65);
  @media (max-width: 1024px) {
    line-height: 31px;
  }
}
.ant-menu-item,
.ant-menu-submenu-title {
  padding: 0;
  margin: 0 0.24rem;
}
.ant-menu-horizontal > .ant-menu-item:hover,
.ant-menu-horizontal > .ant-menu-submenu:hover,
.ant-menu-horizontal > .ant-menu-item-active,
.ant-menu-horizontal > .ant-menu-submenu-active,
.ant-menu-horizontal > .ant-menu-item-open,
.ant-menu-horizontal > .ant-menu-submenu-open,
.ant-menu-horizontal > .ant-menu-item-selected,
.ant-menu-horizontal > .ant-menu-submenu-selected {
  color: #405891;
  border-bottom: 2px solid #405891;
}
.compareMenu {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.menuWrapper {
  flex: 0 0 0.64rem;
  @media (max-width: 1024px) {
    min-height: 32px;
  }
}
.bodyWrapper {
  width: 100%;
  box-sizing: border-box;
  flex: 1;
  overflow: auto;
}
::v-deep .el-dialog__body {
   padding: 15px 20px;
}
</style>
